import React from 'react'
import { FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { PaymentAgentProfileDto } from 'api/Wallet/Types/PaymentAgentDto'

interface PaymentAgentProfileModalProps {
  data: PaymentAgentProfileDto
  handleSaveProfile: () => void
  setData: (profile: PaymentAgentProfileDto) => void
  onClose: () => void
  isOpen?: boolean
}

export const PaymentAgentProfileModal: React.FC<PaymentAgentProfileModalProps> = (props) => {
  const { data, handleSaveProfile, isOpen, setData, onClose } = props

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Agent Profile</DialogTitle>
        </DialogHeader>

        <FormField
          label='First Name'
          value={data.firstName ?? ''}
          onChange={(v) => setData({ ...data, firstName: v.target.value })}
        />
        <FormField
          label='Last Name'
          value={data.lastName ?? ''}
          onChange={(v) => setData({ ...data, lastName: v.target.value })}
        />
        <FormField
          label='Email'
          value={data.email ?? ''}
          onChange={(v) => setData({ ...data, email: v.target.value })}
        />
        <FormField
          label='Phone'
          value={data.phone ?? ''}
          onChange={(v) => setData({ ...data, phone: v.target.value })}
        />

        <DialogFooter>
          <Button type='button' onClick={handleSaveProfile}>
            {'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
